import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

export const CommonXAxisTiltTick = ({ x = 0, y = 0, payload }) => {
    const { getFontSize } = useResponsiveStyles();
    if (!payload) return null;

    // Split the payload.value into words
    const words = payload.value.split(" ");

    // Get the first word
    const firstWord = words[0] || "";
    // Get the second word and any remaining words
    const secondLine = words.slice(1).join(" ");

    return (
        <g transform={`translate(${x},${y}) rotate(-45)`}>
            {/* First line (first word) */}
            <text
                x={-25}
                y={0}
                dy={16}
                dx={0}
                textAnchor="start" // Align text to the left
                fill="#666"
                style={getFontSize("body1")}
            >
                {firstWord}
            </text>
            {/* Second line (remaining words) */}
            {secondLine && (
                <text
                    x={-25}
                    y={20} // Adjust vertical spacing for the second line
                    dy={5}
                    textAnchor="start" // Align text to the left
                    fill="#666"
                    style={getFontSize("body1")}
                >
                    {secondLine}
                </text>
            )}
        </g>
    );
};
